export const heroImage =
  'https://cdn.magicpatterns.com/uploads/iTseNPcez6fQNcQJwVMu6i/ChatGPT_Image_10_sept_2026,_20_15_40-Photoroom.webp'

/** Live checkout link. */
export const checkoutUrl =
  'https://the-pickleball-instructor-s-vault.impultienda.ar/checkout'
export const price = '$27'

export const heroBadges: string[] = [
  'Premium 6-in-1 Teaching System',
  '7 Strategic Bonuses',
  'Instant Digital Access',
]

export const finalBadges: string[] = [
  '150+ Ready-to-Teach Lessons',
  '150+ Elite Drills',
  '7 Strategic Bonuses',
  'Instant PDF Access',
  '7-Day Money Back Guarantee',
]

/** The Sunday-night spiral, as told in the sales letter. */
export const sundayNight: string[] = [
  'It’s Sunday, 9:00 PM.',
  'You have a clinic tomorrow morning.',
  'Blank notebook.',
  'Random YouTube clips.',
  'Trying to make the session flow.',
  'Guessing at your players’ level.',
  'Hoping it looks professional.',
]

export interface CostRow {
  problem: string
  impact: string
}

/** "The High Cost of Being Unstructured" table. */
export const costRows: CostRow[] = [
  {
    problem: 'Lost evenings searching for drills that work.',
    impact: 'Your energy is drained before the lesson even starts.',
  },
  {
    problem: 'Repetitive sessions using the same three drills.',
    impact: 'Students plateau and quietly lose motivation.',
  },
  {
    problem: 'Visible improvisation during your clinics.',
    impact: 'You silently erode student trust and your own authority.',
  },
  {
    problem: 'Burnout from planning instead of living life.',
    impact: 'Your passion for coaching slowly turns into a chore.',
  },
]

/** What the Vault actually is. */
export const isThis: string[] = [
  '150+ ready-to-teach lesson plans',
  '150+ elite, categorised drills',
  'A structured progression for every level',
  'Exact cues for fixing technical errors',
  'Session flow for 60, 90 and 120 minutes',
  'Group management for full courts',
  'Assessment rubrics that prove progress',
  'Emergency plans for last-minute sessions',
  'Games and challenges that keep players coming back',
  'A professional onboarding packet for new students',
]

/** Everything included, as listed in the offer section. */
export const included: string[] = [
  '6-Volume Core System — 150 ready-to-teach lessons',
  'Foundations · Technique · Strategy',
  'Doubles · Elite Drills · Coaching Mastery',
  'All 7 strategic bonuses (value $111)',
  '150-Drill Library + “Magic Cues” Cheat Sheet',
  '100% digital PDFs · instant download',
]
